import React from 'react';
import type { InputHTMLAttributes } from 'react';
import type { ChoiceType } from './types';
import MaterialIcon from '../icon/Icon.material';
import { ChoiceStyled, ChoiceWrapStyled } from './Choice.styled';
import { GLOBAL_ICONS } from '../../util/vars';
import { CHOICE_CHECKBOX, CHOICE_RADIO, CHOICE_WRAPPER } from '../../util/data-id';

type Ref = HTMLInputElement;
type HTMLProps = Omit<InputHTMLAttributes<Ref>, 'type'>;
interface Props extends HTMLProps{
  id?: string;
  label?: string;
  type?: ChoiceType;
  indeterminate?: boolean;
}

const Choice = React.forwardRef<Ref, Props>(({
  id,
  label,
  type = 'checkbox',
  indeterminate = false,
  ...other
}: Props, ref): JSX.Element => (
  <ChoiceWrapStyled
    data-id={CHOICE_WRAPPER}
    $type={type}
    $isChecked={'checked' in other ? !!other.checked : false}
    $isDisabled={'disabled' in other ? !!other.disabled : false}
  >
    <ChoiceStyled
      ref={ref}
      id={id}
      type={type}
      aria-label={label}
      {...other as HTMLProps}
    />
    {type === 'checkbox' && (
      <MaterialIcon
        data-id={CHOICE_CHECKBOX}
        icon={GLOBAL_ICONS[indeterminate ? 'checkbox_indeterminate' : 'checkbox']}
      />
    )}
    {type === 'radio' && (
      <MaterialIcon
        data-id={CHOICE_RADIO}
        icon={GLOBAL_ICONS.radio}
      />
    )}
  </ChoiceWrapStyled>
));

export default Choice;
